export default __webpack_public_path__ + "static/media/lp-01-exercise-01.c231dd6f.jpg";